export default __webpack_public_path__ + "static/media/tres-guerras-inabit.e3b75132.svg";